import { render } from "./ReportManager.vue?vue&type=template&id=02251898"
import script from "./ReportManager.vue?vue&type=script&lang=js"
export * from "./ReportManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__